<template>
  <div class="autocomplete">
    <input
      type="text"
      @input="onChange"
      v-model="search"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    />
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      class="autocomplete-results"
    >
      <li
        class="loading"
        v-if="isLoading"
      >
        Loading results...
      </li>
      <li
        v-else
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result.text, result.value)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result.text }}
      </li>
    </ul>
    <div class="wia-loader wia-loader--light">
      <div class="wia-loader__loader"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WIAAutocomplete',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      n: 1,
      isOpen: false,
      results: [],
      search: '',
      isLoading: false,
      arrowCounter: 0,
      l: 0
    }
  },

  methods: {
    onChange () {
      if (this.search.length < 1) {
        this.n = 1
      }
      if (this.search.length > this.l) {
        this.l = this.search.length
        // Let's warn the parent that a change was made
        if (this.search.length > (3 * this.n)) {
          var v = this
          setTimeout(function () {
            v.$emit('input', v.search)
            v.filterResults()
            v.isOpen = true
            // v.n = this.n + 1
          }, 1000)
        }
      } else {
        this.l = this.search.length
        this.n = 1
        this.isOpen = false
      }
      // Is the data given by an outside ajax request?
      if (this.isAsync) {
        this.isLoading = true
      } else {
        // Let's  our flat array
      }
    },
    filterResults () {
      // first uncapitalize all the things
      this.results = this.items.filter((item) => {
        return item.text.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    },
    getSearchText () {
      return this.search
    },
    setResult (result, code) {
      this.search = result
      this.isOpen = false
      this.$emit('select', code)
    },
    onArrowDown (evt) {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      this.search = this.results[this.arrowCounter].text
      this.isOpen = false
      this.setResult(this.results[this.arrowCounter].text, this.results[this.arrowCounter].value)
      this.arrowCounter = -1
    },
    handleClickOutside (evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },
    toggleDisable (value) {
      document.querySelector('.autocomplete input').disabled = value
      if (value) {
        this.search = ''
        this.stopLoader()
        this.n = 1
      }
    },
    startLoader () {
      document.querySelector('.wia-loader').style.display = 'block'
    },
    stopLoader () {
      document.querySelector('.wia-loader').style.display = 'none'
    }
  },
  watch: {
    items: function (val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val
        this.isLoading = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style lang="scss">
  @import "../../style/main";
  .autocomplete {
    position: relative;
    &.disabled{
      input {
        background: #ddd;
        border-color: #999;
      }
    }
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
    width: 100%;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
    padding-left: 5px !important;
    color: #2e2e2e;
    font-size: 14px;
    &:before{
      display: none !important;
     }
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
  .brand-theme-id{
    .autocomplete-result.is-active,
    .autocomplete-result:hover {
      background-color: map-get($colors, main-font-icon-id);
      color: white;
    }

    .autocomplete {
      input{
        font-size: 24px;
        padding-bottom: 0;
        background: transparent ;
        border-radius: 0 !important;
        padding-left: 0;
      }
    }
    .autocomplete.disabled input{
      background: #ddd;
      border-color: #999;
    }
  }

  .brand-theme-mb{
    .autocomplete-result.is-active,
    .autocomplete-result:hover {
      background-color: map-get($colors, main-font-icon-mb);
      color: white;
    }

    .autocomplete {
      input{
        font-size: 24px;
        padding-bottom: 0;
        background: transparent ;
        border-radius: 0 !important;
        padding-left: 0;
      }
    }
    .autocomplete.disabled input{
      background: #ddd;
      border-color: #999;
    }
  }

  .wia-loader--light{
    position: absolute;

    .wia-loader__loader{
      top: 65%;
      width: 4.5rem;
      height: 4.5rem;
    }
  }

  .brand-theme-wp{
    .autocomplete-result.is-active,
    .autocomplete-result:hover {
      background-color: map-get($colors, main-font-icon-wp);
      color: white;
    }
    input{
      min-width: 285px;
      font-size: 24px;
      height: auto;
      border-radius: 5px;
    }
  }

  .brand-theme-wp-2020 {
    .autocomplete {
      position: relative;
      border-bottom: 1px solid #e7e7e7;
      background: 0 0;
      box-sizing: border-box;
      flex-grow: 1;
      input {
        outline: none;
        width: 100%;
        display: block;
        border: 0;
        margin-bottom: 0;
        font-size: 17px;
        border-bottom: none;
        color: #353535;
        padding: 0 0 5px 0;
        background: 0 0;
        height: 25px;
        font-family: Arial, sans-serif;
        font-weight: 400;
      }
    }
  }

  .brand-theme-hp{
    input{
      font-size: 24px;
      padding-bottom: 0px;
      background: transparent;
      border-radius: 0!important;
      padding-left: 0;
      color: #637977;
      border: 0;
      font-family: quicksandregular,Arial;
      font-weight: 400;
      line-height: 24px;
      background-color: transparent;
      border-radius: 0;
      border-bottom: .0625rem solid #bbc9c9;
    }
    .autocomplete-result {
      text-indent: 0 !important;
    }
  }

  .brand-theme-bk{
    input{
      font-size: 24px;
      padding-bottom: 0px;
      background: transparent;
      border-radius: 0!important;
      padding-left: 0;
      color: #637977;
      border: 0;
      font-family: quicksandregular,Arial;
      font-weight: 400;
      line-height: 24px;
      background-color: transparent;
      border-radius: 0;
      border-bottom: .0625rem solid #bbc9c9;
    }
    .autocomplete-result {
      text-indent: 0 !important;
    }
  }
</style>
